import {Controller} from '@hotwired/stimulus';
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = ['profile--optin-phone-edit-modal'];

    openModal(event) {
        event.preventDefault();

        this.profileOptinPhoneEditModalOutlet.openModal();
    }
}